import React from 'react';
import CtAuthenticateCardGruop from './cards/CtAuthenticateCardGroup';

const AuthenticateContent: React.FC = () => {
  return <CtAuthenticateCardGruop />;
};

export default AuthenticateContent;
